module.exports = __webpack_public_path__ + "static/media/title_17.8cf302a5.svg";